var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDarkLightModeSmall = function SvgDarkLightModeSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 48.087
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dark-light-mode-small_svg__b",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#95dbd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b6e6b"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "dark-light-mode-small_svg__a",
    x: 0,
    y: 0.087,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54153"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54131",
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 21261",
    width: 80,
    height: 42.807,
    rx: 21.404,
    fill: "#1b1b1b"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#eff0f6"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108466",
    d: "M61.367 12.181h1.26v3.149h-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108467",
    d: "M61.367 26.665h1.26v3.149h-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108468",
    d: "M67.664 20.368h3.149v1.26h-3.149Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108469",
    d: "M53.18 20.368h3.149v1.26H53.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108470",
    d: "m65.558 16.528 2.226-2.226.891.891-2.226 2.226Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108471",
    d: "m55.317 26.802 2.226-2.226.891.891-2.226 2.227Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108472",
    d: "m65.575 25.452.891-.891 2.227 2.226-.891.891Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108473",
    d: "m55.3 15.209.891-.891 2.229 2.231-.891.891Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108474",
    d: "M61.996 16.589a4.408 4.408 0 1 0 4.408 4.408 4.421 4.421 0 0 0-4.408-4.408Zm0 7.557a3.149 3.149 0 1 1 3.149-3.149 3.158 3.158 0 0 1-3.149 3.149Z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54132"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -.003)",
    filter: "url(#dark-light-mode-small_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 4353",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(9 6.09)",
    fill: "url(#dark-light-mode-small_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "noun-night-mode-2434960",
    d: "M32.723 24.924a9.328 9.328 0 0 1-6.924 4.7 8.958 8.958 0 0 1-1.269.087 9.4 9.4 0 0 1-4.983-17.34.672.672 0 0 1 .94.9 8.059 8.059 0 0 0 8.1 11.913 7.957 7.957 0 0 0 3.19-1.162.672.672 0 0 1 .947.9Z",
    fill: "#202427"
  })))));
};
export default SvgDarkLightModeSmall;